import type { ReactNode } from 'react'
import clsx from 'clsx'

/* ── Card Container ─────────────────────────────────────── */

interface CardProps {
  children: ReactNode
  className?: string
}

export function Card({ children, className }: CardProps) {
  return (
    <div
      className={clsx(
        'bg-gradient-to-br from-white/85 via-white/80 to-fom-50/20 backdrop-blur-xl border border-white/60 rounded-xl overflow-hidden shadow-sm shadow-fom-500/5 ring-1 ring-white/70 transition-all hover:shadow-lg hover:shadow-fom-500/8 hover:from-white/90 hover:to-fom-50/25',
        className,
      )}
    >
      {children}
    </div>
  )
}

/* ── Card Header ────────────────────────────────────────── */

interface CardHeaderProps {
  children: ReactNode
  tag?: string
}

export function CardHeader({ children, tag }: CardHeaderProps) {
  return (
    <div className="px-5 py-2.5 text-[0.68rem] font-bold uppercase tracking-widest text-gray-600 bg-gradient-to-r from-white/70 via-fom-50/25 to-fom-50/40 border-b border-fom-100/50">
      {children}
      {tag && (
        <span className="font-normal normal-case tracking-normal opacity-60 ml-2">
          {tag}
        </span>
      )}
    </div>
  )
}

/* ── Card Body ──────────────────────────────────────────── */

interface CardBodyProps {
  children: ReactNode
  className?: string
}

export function CardBody({ children, className }: CardBodyProps) {
  return <div className={clsx('p-5', className)}>{children}</div>
}
